// this file is automatically generated by git.revision.js script
export const versions = { revision: 'cc1db65c33' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'cc1db65c33';
